import JSONbig from 'json-bigint'
import { API_BASE } from './config.js'

const jsonParser = JSONbig({ storeAsString: true })

function getToken() {
  return localStorage.getItem('token') || ''
}

function request(method, path, body) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken()
  }
  const options = {
    method,
    headers,
    credentials: 'include'
  }
  if (body !== undefined) {
    options.body = JSON.stringify(body)
  }
  return fetch(`${API_BASE}${path}`, options)
    .then(res => res.text())
    .then(text => jsonParser.parse(text))
}

/**
 * 查询我的「个人足迹」
 *
 * 数据来自后端 user_activities 埋点表，前端只读，不提供写入接口。
 * 好友之间的互动（评论 / 点赞 / 成为好友）不在这里，走 listSocialActivities。
 *
 * @param {Object} [params]
 * @param {string} [params.type] 动作类型：PROJECT_CREATE / TAG_CREATE / TIME_BLOCK_CREATE / TASK_COMPLETE，不传或 ALL 表示全部
 * @param {string} [params.range] 时间范围：TODAY / WEEK / MONTH / ALL，默认 ALL
 * @param {number} [params.page] 页码，从 1 开始
 * @param {number} [params.size] 每页条数，最大 50
 * @returns {Promise<{code:number,message:string,data:{list:Array,total:number},success:boolean,timestamp:string}>}
 */
export function listActivities(params) {
  const query = params || {}
  const qs = new URLSearchParams()
  if (query.type) qs.set('type', query.type)
  if (query.range) qs.set('range', query.range)
  if (query.page) qs.set('page', String(query.page))
  if (query.size) qs.set('size', String(query.size))
  const suffix = qs.toString() ? `?${qs.toString()}` : ''
  return request('GET', `/api/v1/activities${suffix}`)
}

/**
 * 查询我的「好友互动」动态
 *
 * 后端从评论 / 点赞 / 好友关系实时派生，不额外埋点。
 * 每条含 type（COMMENT_OUT / COMMENT_IN / LIKE_OUT / LIKE_IN / FRIEND_ADD）、
 * direction（OUT 我作用于好友 / IN 好友作用于我）、好友昵称与头像、资源名称与时段、评论内容。
 *
 * @param {Object} [params]
 * @param {number} [params.page] 页码，从 1 开始
 * @param {number} [params.size] 每页条数，最大 50
 * @returns {Promise<{code:number,message:string,data:{list:Array,total:number},success:boolean,timestamp:string}>}
 */
export function listSocialActivities(params) {
  const query = params || {}
  const qs = new URLSearchParams()
  if (query.page) qs.set('page', String(query.page))
  if (query.size) qs.set('size', String(query.size))
  const suffix = qs.toString() ? `?${qs.toString()}` : ''
  return request('GET', `/api/v1/social/activities${suffix}`)
}
